import React from 'react';
import { RealEstateAgent } from '../../../utility/types';
import { Loader } from '../../icons/OurIcons';
import { PropertyDetailError } from '../PropertyDetailError';
import { PropertyDetailAgentDisplay } from './PropertyDetailAgentDisplay';

type PropertyDetailAgentHandlerProps = {
  agent: RealEstateAgent | null;
  publicRemarks: string;
  isLoading: boolean;
  error: Error | null;
};

export const PropertyDetailAgentHandler = ({
  agent,
  publicRemarks,
  isLoading,
  error,
}: PropertyDetailAgentHandlerProps) => {
  if (isLoading) {
    return (
      <div className="mx-auto my-10 w-48">
        <Loader />
      </div>
    );
  }

  if (error) {
    return <PropertyDetailError error={error} title="real estate agent" />;
  }

  if (!agent) {
    return null;
  }

  return (
    <div className="m-12">
      <PropertyDetailAgentDisplay listingAgent={agent} publicRemarks={publicRemarks} />
    </div>
  );
};
